"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservationDefinitionQuantitativeDetails = void 0;
/**
 * Set of definitional characteristics for a kind of observation or measurement produced or consumed by an orderable health care service.
 */
var ObservationDefinitionQuantitativeDetails = /** @class */ (function () {
    function ObservationDefinitionQuantitativeDetails() {
    }
    return ObservationDefinitionQuantitativeDetails;
}());
exports.ObservationDefinitionQuantitativeDetails = ObservationDefinitionQuantitativeDetails;
